import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import T from '../Locale';
import { UserToUpdate, UserFields } from '../SignupForm.constants';
import ContinueButton from '../components/ContinueButton';
import UserForm from './components/UserForm';
const { PARTNER_PRESENT, IS_ADVISOR } = UserFields;
const UserInfoStep = ({ partner, user, updateUser, errors, onSave }) => {
    const [errorsInStep, setErrorsInStep] = useState({});
    /**
     * Clear errors for a specific field.
     *
     * @param {string} field
     */
    const clearError = (field) => {
        const newErrors = Object.assign({}, errorsInStep);
        delete newErrors[field];
        setErrorsInStep(newErrors);
    };
    /**
     * Update the user with the value and reset errors for the field.
     *
     * @param {string} field
     * @param {string} value
     * @param {string} user
     */
    const updateUserValue = (field, value, user) => {
        const fieldCapitalized = field.charAt(0).toUpperCase() + field.slice(1);
        clearError(`${user}${fieldCapitalized}`);
        updateUser({ [field]: value }, user);
    };
    useEffect(() => {
        setErrorsInStep(errors);
    }, [errors]);
    return (_jsxs("div", Object.assign({ className: 'flex flex-col' }, { children: [_jsx("h3", Object.assign({ className: 'w-full text-center tailwind-reset text-3xl font-bold text-viva-red' }, { children: T(user[PARTNER_PRESENT] ? 'partner.signup.multiple_title' : 'partner.signup.single_title') })), user[IS_ADVISOR] && (_jsx("p", Object.assign({ className: 'text-center font-semibold text-viva-red' }, { children: T(user[PARTNER_PRESENT] ? 'partner.signup.multiple_description' : 'partner.signup.single_description') }))), partner.sectionClientSubtext && (_jsx("div", Object.assign({ className: 'font-light' }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: partner.sectionClientSubtext } }) }))), _jsx(UserForm, { partner: partner, onChangeValue: updateUserValue, errors: errorsInStep, userToUpdate: UserToUpdate.FIRST, partnerPresent: user[PARTNER_PRESENT] }), user[PARTNER_PRESENT] && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'flex flex-col' }, { children: [_jsx("h3", Object.assign({ className: 'w-full text-center tailwind-reset text-3xl font-light' }, { children: T('partner.signup.partnerTitle') })), _jsx("p", Object.assign({ className: 'text-center font-light' }, { children: T('partner.signup.partnerDescription', { partner: partner.name }) }))] })), _jsx(UserForm, { partner: partner, onChangeValue: updateUserValue, errors: errorsInStep, userToUpdate: UserToUpdate.SECOND, partnerPresent: user[PARTNER_PRESENT] })] })), onSave != null && _jsx(ContinueButton, { onClick: onSave, id: 'user-info' })] })));
};
UserInfoStep.propTypes = {
    partner: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    onSave: PropTypes.func
};
export default UserInfoStep;
